/* ====================================================================
   Add to cart from the home page

   The forms this upgrades work without it: they are real forms posting
   to /cart/add, and with no JavaScript the browser posts them and lands
   on the cart. This turns that into an add that leaves the reader where
   they were, which on a page whose whole job is browsing is the
   difference between one purchase and one.

   Delegated from the document, so it covers every deals grid on the
   page and anything the theme editor adds after load without rebinding.
   ==================================================================== */

(() => {
  const BUSY = 'is-busy';
  const DONE = 'is-done';

  async function refreshCount() {
    // The header bubble is Dawn's. Read the true count from the cart
    // rather than incrementing what is on screen: a second tab, or a
    // line already in the cart, makes local arithmetic a lie.
    try {
      const cart = await fetch(window.Shopify?.routes?.root
        ? `${window.Shopify.routes.root}cart.js`
        : '/cart.js').then((r) => r.json());

      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') publish(PUB_SUB_EVENTS.cartUpdate, {source:'pet-shelf',cartData:cart});
      document.querySelectorAll('.cart-count-bubble span[aria-hidden="true"]').forEach((el) => {
        el.textContent = cart.item_count;
      });

      const bubble = document.querySelector('.cart-count-bubble');
      const icon = document.querySelector('#cart-icon-bubble');
      if (cart.item_count > 0 && !bubble && icon) {
        // Dawn only renders the bubble when the cart is not empty, so
        // the first add of a session has nothing to update.
        const made = document.createElement('div');
        made.className = 'cart-count-bubble';
        made.innerHTML = `<span aria-hidden="true">${cart.item_count}</span>`;
        icon.appendChild(made);
      }
    } catch (e) {
      /* The line is in the cart either way; the count catches up on the
         next page load. */
    }
  }

  document.addEventListener('submit', async (event) => {
    const form = event.target.closest('form[data-pp-add]');
    if (!form) return;

    event.preventDefault();

    const button = form.querySelector('button');
    if (!button || button.classList.contains(BUSY)) return;

    button.classList.add(BUSY);
    button.disabled = true;

    try {
      const response = await fetch(form.action, {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: new FormData(form),
      });

      if (!response.ok) throw new Error(response.status);

      button.classList.remove(BUSY);
      button.classList.add(DONE);
      await refreshCount();

      window.setTimeout(() => {
        button.classList.remove(DONE);
        button.disabled = false;
      }, 1800);
    } catch (e) {
      // Out of stock between render and click, or the network went
      // away. Fall back to the plain post, which lands on the cart and
      // shows whatever Shopify has to say about it.
      button.classList.remove(BUSY);
      button.disabled = false;
      form.submit();
    }
  });
})();
